export default __webpack_public_path__ + "dist/media/Email-white.b84e559c.svg";